fx.ns("shared.stage.components", class Photo extends shared.stage.base.MediaComponent {

    constructor(component, model, baseSVG, manual, commands) {
        super(component, model, baseSVG, commands, model.photos, manual);

        this.photoeffects = model.photofilters;

        this.movable = fx.get("app") != "print";
        this.editable = true;//fx.get("app") != "print";
        this.resizable = fx.get("app") != "print";
        this.movableWhenActive = fx.get("app") != "print";
        this.innerDragEnabled = true;//fx.get("app") != "print";
        this.avoidlostBorder = true;
        this._draggingOver = false;

        this._pendingMediaRefresh = false;

        this._toFill = manual;

        this._toCheck = manual;

        this._clipfix = 0.2;


        this._emptySize = {
            width: this.data.width,
            height: this.data.height,
            imageContainerWidth: 0,
            imageContainerHeight: 0,
            xInner: 0,
            yInner: 0,
            widthInner: 0,
            heightInner: 0,
            imageXInner: 0,
            imageYInner: 0
        }

        this.filterFCNHandler = this.filterFCNBrightness.bind(this);
    }

    /**************** Getters / Setters ****************/



    get draggingOver() {
        return this._draggingOver;
    }

    set draggingOver(val) {
        this._draggingOver = val;

        // a repoint asked for while dragging over was postponed : apply it now
        if (!val && this._pendingMediaRefresh) {
            this._pendingMediaRefresh = false;
            this._repointMedia();
        }
    }

    get emptySize() {
        return this._emptySize;
    }

    get mask() {
        return this.model ? this.model.masks.find({ id: this.data.photomask }) : null;
    }

    get photoEffect() {
        return this._photoEffect;
    }

    set photoEffect(val) {
        this._effects = this._effects || {};

        if (!this._effects[val])
            this._effects[val] = this.photoeffects.get(val);

        this._photoEffect = this._effects[val];
    }


    get width() {
        return this._resizeData ? this._resizeData.width : (this.data.width || 0);
    }

    get height() {
        return this._resizeData ? this._resizeData.height : (this.data.height || 0);
    }

    get widthInner() {
        if (this.empty)
            return this.emptySize.widthInner;

        if (this.rotationInner == 0 || this.rotationInner == 180)
            return this._resizeData ? this._resizeData.width_inner : (this.data.width_inner || 0);
        else
            return this._resizeData ? this._resizeData.height_inner : (this.data.width_inner || 0);
    }

    get heightInner() {
        if (this.empty)
            return this.emptySize.heightInner;

        if (this.rotationInner == 0 || this.rotationInner == 180)
            return this._resizeData ? this._resizeData.height_inner : (this.data.height_inner || 0);
        else
            return this._resizeData ? this._resizeData.width_inner : (this.data.height_inner || 0);
    }

    // case when rotation_inner is undefined
    get rotationInner() {
        return this.data.rotation_inner || 0;
    }

    get xInner() {
        if (this.empty)
            return this.emptySize.xInner;

        return this._resizeData ? this._resizeData.x_inner : (this.data.x_inner || 0);
    }

    get yInner() {
        if (this.empty)
            return this.emptySize.yInner;

        return this._resizeData ? this._resizeData.y_inner : (this.data.y_inner || 0);
    }


    get imageContainerWidth() {
        if (this.empty)
            return this.emptySize.imageContainerWidth;

        if (this.rotationInner == 0 || this.rotationInner == 180)
            return this.widthInner;
        else
            return this.heightInner;
    }

    get imageContainerHeight() {
        if (this.empty)
            return this.emptySize.imageContainerHeight;

        if (this.rotationInner == 0 || this.rotationInner == 180)
            return this.heightInner;
        else
            return this.widthInner;
    }

    get imageXInner() {
        if (this.empty)
            return this.emptySize.imageXInner;

        if (this.rotationInner == 0)
            return 0;

        if (this.rotationInner == 90)
            return this.imageContainerWidth;

        if (this.rotationInner == 180)
            return this.imageContainerWidth;

        if (this.rotationInner == 270)
            return 0;

    }

    get imageYInner() {
        if (this.empty)
            return this.emptySize.imageYInner;

        if (this.rotationInner == 0)
            return 0;

        if (this.rotationInner == 90)
            return 0;

        if (this.rotationInner == 180)
            return this.imageContainerHeight;

        if (this.rotationInner == 270)
            return this.imageContainerHeight;
    }

    get isSmall() {
        //return (this.widthInner * this.heightInner < 80 * 80);
        //return (this.width * this.data.height < 80 * 80);
        return this.data.width < 80 && this.data.height < 80;
    }


    // automatic colour correction (enhance.PhotoEnhancer) : screenshot app only, creations.to_enhance = 1
    get enhancing() {
        return fx.get("app") == "screenshot" && !!fx.get("enhance-photos");
    }

    // the customer chose how this photo looks : an effect, or brightness / saturation / contrast
    get hasCustomerLook() {
        return !!(this.data.effectName || Number(this.data.luminosity) || Number(this.data.saturation) || Number(this.data.contrast));
    }

    get hasFilteredPhoto()
    {
        return !!this.data.content_type;
    }

    // ai effect
    get effect()
    {
        return this.data.content_type;
    }

    /*********************** Overrides **********************/


    create() {

        this.attr("data-drop-allowed", true);

        this.svg = SVG(this.id);


        // TODO : move clip to SVGElement, or subgroup in order to avoid Photo SVG having the same size as image
        this.SVGElement = this.svg.group();

        this._progressBackground = this.SVGElement.rect(this.width, this.height)
            .move(0, 0)
            .back()
            .addClass("background");

        //   imageContainer is used for translation, it always has the size of visible image (when rotated, we have to invert scaledWidth/scaledHeight)                                    
        this.imageContainer = this.SVGElement.group()
            .attr("class", "container");

        // Photo, it always positionned properly in it's imageContainer
        this.image = this.imageContainer.image("")
            .attr("draggable", false);

    }


    onDataEvent(event) {
        super.onDataEvent(event);

        switch (event.type) {

            case "faces-updated" :
                this.fill();
                break;

            case "drag-over":

                if (event.detail.overcontent == this.data.content)
                    return;

                this._toFill = "temporary";
                this.draggingOver = true;
                this.updateMedia(event.detail.overcontent);
                event.stopPropagation();               
                break;

            case "drag-out":

                this.draggingOver = false;
                
                this.updateMedia(this.data.content);

                this.imageContainer.size(this.imageContainerWidth, this.imageContainerHeight)
                .attr("transform", "translate(" + this.xInner + "," + this.yInner + ")");

                this.image.size(this.widthInner, this.heightInner)
                .attr("transform", "translate(" + this.imageXInner + "," + this.imageYInner + ") rotate(" + this.rotationInner + ")");

                event.stopPropagation();
                break;

            case "drop" :

                this.data.update("drop", event.data);

            break;

            case "refresh-media":
                this.media.refresh();
                this.updateMedia(this.data.content);
                break;

            case "media-file-uploaded":
                if (this.hasFilteredPhoto)
                    this.fill();
                break;

            case "photo-effect-applied" :
                console.log(event);
            break;

        }
    }

    onDataUpdated(action) {
        super.onDataUpdated(action);

        if (action.model instanceof models.Photo && action.impacts("processing"))
            this._processingAnimation();

        if (action.model instanceof models.Photo && action.impacts("analysing"))
        {
            this._loadingState(action.model.analysing);

            if (!this.media.analysing)
                this._updateFaces();
        }

        if (action.model instanceof models.Photo && action.impacts("urls") && !this.draggingOver)
        {
            this.updateMedia(this.data.content);
        }

        // url / light_url alone (end of an upload) : the model has just revoked its blob, so the
        // <image> points to a dead url. Only the href is repointed here : replaying updateMedia
        // would run a fill() before the faces analysis has landed, and lose the face centering.
        if (action.model instanceof models.Photo && action.model == this.media
            && action.impacts("url", "light_url") && !action.impacts("urls"))
        {
            if (this.draggingOver)
                this._pendingMediaRefresh = true;
            else
                this._repointMedia();
        }
            
        
        if (action.model instanceof models.CreationElementContent && action.type == "init") {
            this.attr("data-id", this.data.id);

            if (!this.data.width_inner || !this.data.content)
                this._toFill = true;


            // Effect
            this.photoEffect = this.data.effectName;
            //this.photoEffect.apply(this.SVGElement);

            this._autoCorrectColors();

            // Brightness
            this.SVGElement.filter(this.filterFCNHandler);
            
            // Mask

            if (this.mask && this.mask.custom)
                this.applyCustomMask()
            else
                if (this.mask && this.mask.svg)
                    this.SVGElement.svg(this.mask.svg);
                else
                    this.SVGElement.svg('<rect id="photo-clip"/>');

            let clip = this.find("#photo-clip");

            if (clip)
                this.initClip()

            this.updateMedia(this.data.content);

            this._loadingState(this.media.isHeic && !this.media.url, fx.text(""));

            this.updateBorder();

            this._updateFaces();

            this._processingAnimation();

            this._updateFilteredPhoto();

            return;
        }

        if (action.model instanceof models.CreationElementContent && (action.impacts("side") || action.impacts("borderid")))
            this.updateBorder();


        if (action.model instanceof models.CreationElementContent && (action.impacts("zoom") && !action.impacts("rotation_inner")) && action.tag != "drag-out") {
            if (this.image.fx && this.image.fx.play) {
                this.image.finish();
                this.imageContainer.finish();
            }

            this.imageContainer.size(this.imageContainerWidth, this.imageContainerHeight)
                .attr("transform", "translate(" + this.xInner + "," + this.yInner + ")");

            this.image.size(this.widthInner, this.heightInner)
                .attr("transform", "translate(" + this.imageXInner + "," + this.imageYInner + ") rotate(" + this.rotationInner + ")");

            this.updateCommands();
            this._checkResolution();
        }
        else
        if (action.model instanceof models.CreationElementContent && action.impacts("width_inner", "height_inner") && action.tag != "drag-out") {
            this.imageContainer.size(this.imageContainerWidth, this.imageContainerHeight)
                .attr("transform", "translate(" + this.xInner + "," + this.yInner + ")");

            this.image.size(this.widthInner, this.heightInner)
                .attr("transform", "translate(" + this.imageXInner + "," + this.imageYInner + ") rotate(" + this.rotationInner + ")");
        }
        else
        if (action.model instanceof models.CreationElementContent && action.impacts("x_inner", "y_inner") && action.tag != "drag-out")
        {
            this.imageContainer.attr("transform", "translate(" + this.data.x_inner + "," + this.data.y_inner + ")");
        }
            

        if (action.model instanceof models.Photo && action.impacts("effects") && this.effect)
        {
            for(let i = 0; i < this.media.effects.length; i++)
            {
                let effect = this.media.effects.getItemAt(i);
                
                let cache = this.media.getCache(effect.name);
                if (cache)
                {
                    cache.width = effect.width;
                    cache.height = effect.height;
                    
                }

                if (effect.name == this.effect)
                {
                    this._toFill = true;
                    this.renderMedia();
                }
                
            }

            //this.media.load(this.effect);
        }
            

        if (action.model instanceof models.Photo && action.impacts("initializing")) {

            if (action.model.initializing == false)
            {
                this._toFill = true;
                //this.media.refresh();
                this.updateMedia(this.data.content);
                this.loading(false);
            }
            else
                   this.loading(true);
        }
        
        if ((action.model instanceof models.CreationElementContent && action.impacts("content_type")))
        {
            // an erased version has the size of the one it was made from : keep the framing, also
            // when the editor's undo goes back from it
            let eraser = fx.service("MagicEraserService");
            let previous = action.previous ? action.previous.content_type : "";
            this._toFill = action.tag != "magic-erase" && !eraser.isErased(this.effect) && !eraser.isErased(previous);
            this._updateFilteredPhoto();
            this.updateMedia(this.data.content, true);
        }
            

        if ((action.model instanceof models.CreationElementContent && action.impacts("content"))) {
            if (!this.draggingOver || action.tag == "drop") {
                // fill only if content changed by user action, so :
                // - not from history
                // - not from update-id (upload)
                // - not from smart-crop (the creator already set the inner rect from smartcrop)
                // - not from magic-erase (the erased photo has the size of the one it replaces)
                if (!action.history && action.tag != "update-id" && action.tag != "smart-crop" && action.tag != "magic-erase")
                    this._toFill = true;

                //if (action.tag !== "update-id")
                //if (action.tag === "update-id")
                  //  this.media.refresh(); // clean media cache

                //this.updateMedia(this.data.content, !this.media.isTemporary);
                this.updateMedia(this.data.content, true); 
                
                this._loadingState(this.media.initializing);

                this._processingAnimation();
                
            }
        }

     
        if (action.model instanceof models.CreationElementContent && action.impacts("effectName")) {
            this.SVGElement.unfilter(true);
            //this.photoEffect.clear();
            this.photoEffect = this.data.effectName;
            //this.photoEffect.apply(this.SVGElement);
            //this._updatePhoto();

            // Brightness
            this.SVGElement.filter(this.filterFCNHandler);

            this.updatePhoto();
        }

        if (action.model instanceof models.CreationElementContent && action.impacts("rotation_inner")) {
            this.fill();
            return;
        }

        if (action.model instanceof models.CreationElementContent && action.impacts("photomask")) {
            if (this.mask) {
                if (this.mask.svg) {
                    this.removeCustomMask();
                    this.addClip();
                }
                else
                    if (this.mask.custom) {
                        this.removeClip();
                        this.applyCustomMask();
                    }
                    else {

                    }
            }
            else {
                this.removeClip();
                this.removeCustomMask();;
            }

            this.updatePhoto();
        }

        if (action.model instanceof models.CreationElementContent)
            this.updateCommands();

        if (action.impacts("id"))
            this.attr("data-id", this.data.id);
    }

    _updateFilteredPhoto()
    {
        this.toggleClass("FilteredPhoto", this.hasFilteredPhoto);
    }

    _updateFaces()
    {
        if (!Utils.getURLParam("show-faces")) // add "?show-faces=true to url in order to seeing faces rects
            return; 

        if (!this._facesRect)
            this._facesRect = [];

        if (this._facesRect.length > 0)
        {
            for(let i = 0; i < this._facesRect.length; i++)
                this._facesRect[i].remove();

            this._facesRect = [];
        }

        if (this.media.hasFaces)
        {
            let rectFaces = this.media.facesPositions;
            for (let i = 0; i < rectFaces.length; i++)
            {
                let rectFace = rectFaces[i];

                this._facesRect.push( this.SVGElement.rect(rectFace.width * this.widthInner, rectFace.height * this.heightInner)
                                            .move(rectFace.x * this.widthInner + this.xInner, rectFace.y * this.height + this.yInner)
                                            .stroke({ width: 1, color: '#f06' })
                                            .fill("transparent") );
            }

            this._facesRect.push( this.SVGElement.rect(this.media.importantRectFaces.width * this.widthInner, this.media.importantRectFaces.height * this.heightInner)
                                            .move(this.media.importantRectFaces.x * this.widthInner + this.xInner, this.media.importantRectFaces.y * this.height + this.yInner)
                                            .stroke({ width: 1, color: '#0F6' })
                                            .fill("transparent") );

        }
    }

    _loadingState(val, text)
    {
        this.loading(val || (this.media && this.media.analysing) , text || "");
    }

    _processingAnimation()
    {
        if (this.media.processing)
        {
            if (!this._processingAnimationContainer)
            {
                this._processingAnimationContainer = new fx.components.ScanBox({text : fx.text("Magie en cours...")});
                this.addChild(this._processingAnimationContainer, {top:0, left:0,width:"100%", height:"100%"});
            }
        }
        else
        {
            if (this._processingAnimationContainer)
            {
                this.removeChild(this._processingAnimationContainer, true);
                this._processingAnimationContainer = null;
            }
        }
    }

    updateDisplayComponents()
    {
        if (this._processingAnimationContainer)
            this._processingAnimationContainer.updateDisplay();

    }

    initClip() {
        this.find("#photo-clip").setAttribute("id", "photo-clip-" + this.id);

        this.clip = SVG.get("photo-clip-" + this.id).attr("preserveAspectRatio", "none");

        this.clipSVG = this.SVGElement.clip();

        if (this.clip)
            this.clipSVG.add(this.clip);

        this.SVGElement.clipWith(this.clipSVG);
    }

    addClip(init) {
        if (!init)
            this.removeClip();

        this.SVGElement.svg(this.mask.svg);
        let tmpID = Utils.newID();
        this.find("#photo-clip").setAttribute("id", "photo-clip-" + tmpID);
        this.clip = SVG.get('photo-clip-' + tmpID);
        this.clip.attr("preserveAspectRatio", "none");

        this.clip.size(this.width + this._clipfix, this.height + this._clipfix); // hack in order to fix white line
        this.clip.move(0, 0);

        this.clipSVG = this.SVGElement.clip();
        this.clipSVG.add(this.clip);
        this.SVGElement.clipWith(this.clipSVG);
    }

    removeClip() {
        if (this.clip) {
            this.SVGElement.unclip();

            this.clip.remove();
            this.clipSVG.remove();

            this.clip = null;
            this.clipSVG = null;
        }

    }

    removeCustomMask() {
        if (this.maskElement) {
            this.SVGElement.unmask();

            this.maskElement.remove();
            this.maskSVG.remove();
            this.radialMask.remove();

            this.maskElement = null;
            this.maskSVG = null;
            this.radialMask = null;
        }
    }

    applyCustomMask() {
        switch (this.mask.custom) {
            case "radial":

                this.removeClip();

                //let baseSVG = this.SVGElement.parent();

                this.radialMask = this.SVGElement.gradient('radial', function (add) {
                    add.at(0, 'rgba(255,255,255,1)');
                    add.at(0.5, 'rgba(255,255,255,1)');
                    add.at(0.7, 'rgba(255,255,255,0.7)');
                    add.at(1, 'rgba(0,0,0,0)');
                });

                this.maskElement = this.SVGElement.ellipse(this.with, this.height).move(0, 0).fill(this.radialMask);
                this.maskSVG = this.SVGElement.mask().add(this.maskElement);
                this.SVGElement.maskWith(this.maskSVG);
                break;
        }

    }

    updatePhoto() {
        this.delay(this._updatePhoto, 0);
    }


    get minComponentSize() {
        return {
            height: 15,
            width: 15
        }
    }

    resize(width, height, side) {
        if (width === undefined) return;

        let width_inner;
        let height_inner;

        if (this.rotationInner == 0 || this.rotationInner == 180) {
            width_inner = this.empty ? this.data.width : this.data.width_inner;
            height_inner = this.empty ? this.data.height : this.data.height_inner;
        }
        else {
            width_inner = this.empty ? this.data.height : this.data.height_inner;
            height_inner = this.empty ? this.data.width : this.data.width_inner;
        }

        // we nevey update data properties, everything is temporary, so let's store everything in this._resizeData
        if (!this._resizeData)
            this._resizeData = {
                width: this.data.width,
                height: this.data.height,
                width_inner: width_inner,
                height_inner: height_inner,
                x_inner: this.data.x_inner,
                y_inner: this.data.y_inner,

            };


        // side : left,bottom,right,top
        // - left / right -> on agit sur la largeur
        // - top / bottom : on agit sur la hauteur
        // - undefined : on agrandit l'image

        // 3 cas :
        // - on ne fait qu'élagir la zone visible (largeur photo supérieur à largeur conteneur)
        // - on arrive au bout de la photo, alors la photo se déplace dans le mouvement du déplacement pour ne laisser voir plus
        // - la largeur de la photo est égale à la taille du conteneur, alors la largeur de la photo est agrandie

        if (side == "left" || side == "right") {
            this._resizeData.width = width;

            if (side == "left" && this.data.x_inner + width_inner > width) {
                if (this.data.x_inner < 0)
                    this._resizeData.x_inner = Math.min(0, this.data.x_inner - (this.data.width - width));
                else
                    this._resizeData.x_inner = Math.min(0, this.data.x_inner - (this.data.width - width));
            }
            else
                if (side == "right" && this.data.x_inner + width_inner > width) {
                }
                else
                    if (this.data.x_inner + width_inner <= width && width_inner > width) {
                        if (side == "left")
                            this._resizeData.x_inner = Math.min(0, this.data.x_inner - (this.data.width - width));
                        else
                            this._resizeData.x_inner = Math.min(0, width - width_inner);
                    }
                    else
                        if (this.data.x_inner + width_inner <= width && width_inner < width) {
                            this._resizeData.width_inner = width;
                            this._resizeData.height_inner = height_inner * width / width_inner;

                            this._resizeData.x_inner = 0;

                            let y = Math.abs(this.data.y_inner) + Number(this.data.height) / 2;
                            let ratio = this._resizeData.width_inner / width_inner;
                            let newY = y * ratio;
                            this._resizeData.y_inner = this.data.y_inner - (newY - y);

                        }
        }
        else
            if (side == "top" || side == "bottom") {
                this._resizeData.height = height;

                if (side == "top" && this.data.y_inner + height_inner > height) {
                    if (this.data.y_inner < 0)
                        this._resizeData.y_inner = Math.min(0, this.data.y_inner - (this.data.height - height));
                    else
                        this._resizeData.y_inner = Math.min(0, this.data.y_inner - (this.data.height - height));
                }
                else
                    if (side == "bottom" && this.data.y_inner + height_inner > height) {
                    }
                    else
                        if (this.data.y_inner + height_inner <= height && height_inner >= height) {
                            if (side == "top")
                                this._resizeData.y_inner = Math.min(0, this.data.y_inner - (this.data.height - height));
                            else
                                this._resizeData.y_inner = Math.min(0, height - height_inner);
                        }

                        else
                            if (this.data.y_inner + height_inner <= height && height_inner < height) {
                                this._resizeData.height_inner = height;
                                this._resizeData.width_inner = width_inner * height / height_inner;

                                this._resizeData.y_inner = 0;

                                let x = Math.abs(this.data.x_inner) + Number(this.data.width) / 2;
                                let ratio = this._resizeData.height_inner / height_inner;
                                let newX = x * ratio;
                                this._resizeData.x_inner = this.data.x_inner - (newX - x);
                            }
            }
            else {
                this._resizeData.width = width;
                this._resizeData.height = height;

                let ratio = width / this.data.width;
                this._resizeData.width_inner = width_inner * ratio;
                this._resizeData.height_inner = height_inner * ratio;

                if (this._resizeData.width_inner < this._resizeData.width) {
                    this._resizeData.width_inner = this._resizeData.width;
                    this._resizeData.height_inner = this._resizeData.width * ((this.data.height_inner > 0) ? (this.data.height_inner / this.data.width_inner) : 1);
                }
                else
                    if (this._resizeData.height_inner < this._resizeData.height) {
                        this._resizeData.height_inner = this._resizeData.height;
                        this._resizeData.width_inner = this._resizeData.height * ((this.data.height_inner > 0) ? (this.data.width_inner / this.data.height_inner) : 1);
                    }

                this._resizeData.x_inner = this.data.x_inner * ratio;
                this._resizeData.y_inner = this.data.y_inner * ratio;
            }


        this.emptySize.width = width;
        this.emptySize.height = height;

        if (this.empty)
            this.fill();


        this.data.update("resize");
        //this._updatePhoto();

        return true;
    }

    resizeEnd() {
        if (this._resizeData) {
            let properties = {
                x_inner: this._resizeData.x_inner,
                y_inner: this._resizeData.y_inner,
                width_inner: this._resizeData.width_inner,
                height_inner: this._resizeData.height_inner,
                width: this._resizeData.width,
                height: this._resizeData.height,
            };

            if (this.rotationInner == 90 || this.rotationInner == 270) {
                properties.width_inner = this._resizeData.height_inner;
                properties.height_inner = this._resizeData.width_inner;
            }

            this._resizeData = null;

            this.data.update("resize-end", properties);


            this.emptySize.width = this.data.width;
            this.emptySize.height = this.data.height;

            if (this.empty)
                this.fill();

            this._checkResolution();
        }
    }


    fill(mode) {
        if (!this.photoDimensions || !this.photoDimensions.width || !this.photoDimensions.height)
            return false;

        let scaledWidth,
            scaledHeight,
            widthInner,
            heightInner,
            xInner,
            yInner,
            componentWidth = this.empty ? this.emptySize.width : this.data.width,
            componentHeight = this.empty ? this.emptySize.height : this.data.height;

        if (this.rotationInner == 0 || this.rotationInner == 180) {
            scaledWidth = Number(componentHeight) * this.photoDimensions.width / this.photoDimensions.height;
            scaledHeight = Number(componentWidth) * this.photoDimensions.height / this.photoDimensions.width;

            if (scaledWidth >= Number(componentWidth)) {
                widthInner = scaledWidth;
                heightInner = Number(componentHeight);
            }
            else {
                widthInner = Number(componentWidth);
                heightInner = scaledHeight;
            }
        }
        else // 90 - 270
        {
            scaledWidth = Number(componentWidth) * this.photoDimensions.width / this.photoDimensions.height;
            scaledHeight = Number(componentHeight) * this.photoDimensions.height / this.photoDimensions.width;

            if (scaledWidth > Number(componentHeight)) {
                heightInner = Number(componentWidth);
                widthInner = scaledWidth;
            }
            else {
                widthInner = Number(componentHeight);
                heightInner = scaledHeight;
            }
        }

        let imageContainerWidth,
            imageContainerHeight;

        if (this.rotationInner == 0 || this.rotationInner == 180)
            imageContainerWidth = widthInner;
        else
            imageContainerWidth = heightInner;

        if (this.rotationInner == 90 || this.rotationInner == 270)
            imageContainerHeight = widthInner;
        else
            imageContainerHeight = heightInner;

        xInner = -(imageContainerWidth - Number(componentWidth)) / 2;
        yInner = -(imageContainerHeight - Number(componentHeight)) / 2;

        // center faces
        if (this.media.hasFaces) {
          
            let rectFaces = this.media.importantRectFaces;

            // case when rectFaces is wider that photo component
            // TODO : find best strategy :
            // - try to center on the biggest pictures
            // - eliminate picture from left and right incrementally

            if (this.rotationInner == 0 || this.rotationInner == 180) 
            {
                if (rectFaces.width * widthInner > componentWidth || rectFaces.height * heightInner > componentHeight) 
                {
                    let groups = this.media.getAllRectFaces();
                    rectFaces = rectFaces; //groups.getItemAt(0);

                    for (let i = 0; i < groups.length; i++) 
                    {
                        let rect = groups.getItemAt(i);

                        if (rect.width * widthInner < componentWidth && rect.height * heightInner < componentHeight)
                            rectFaces = rect;
                    }
                }
            }
            else 
            {
                if (rectFaces.height * heightInner > componentWidth) 
                {
                    let groups = this.media.getAllRectFaces();
                    groups;
                }


                if (rectFaces.height * heightInner > componentWidth || rectFaces.width * widthInner > componentHeight) 
                {
                    let groups = this.media.getAllRectFaces();
                    rectFaces = groups.getItemAt(0);

                    for (let i = 0; i < groups.length; i++) 
                    {
                        let rect = groups.getItemAt(i);

                        if (rect.height * heightInner < componentWidth && rect.width * widthInner < componentHeight)
                            rectFaces = rect;
                    }
                }
            }

            if (rectFaces.x !== undefined && rectFaces.y !== undefined && rectFaces.width !== undefined && rectFaces.height !== undefined)
            {
                if (this.rotationInner == 0) {
                    xInner = -Math.max(0, rectFaces.x * widthInner - (componentWidth - rectFaces.width * widthInner) / 2);
                    yInner = -Math.max(0, rectFaces.y * heightInner - (componentHeight - rectFaces.height * heightInner) / 3);

                    if (xInner > 0)
                        xInner = 0;

                    if (yInner > 0)
                        yInner = 0;

                    if (xInner + widthInner < componentWidth)
                        xInner = componentWidth - widthInner;

                    if (yInner + heightInner < componentHeight)
                        yInner = componentHeight - heightInner;
                }
                else if (this.rotationInner == 90) 
                {
                    xInner = - imageContainerWidth + rectFaces.y * heightInner + (componentWidth + rectFaces.height * heightInner) / 2;
                    yInner = -(rectFaces.x * widthInner) + (componentHeight - rectFaces.width * widthInner) / 2;

                    if (xInner > 0)
                        xInner = 0;

                    if (yInner > 0)
                        yInner = 0;

                    if (xInner < componentWidth - heightInner)
                        xInner = componentWidth - heightInner;

                    if (yInner + widthInner < componentHeight)
                        yInner = componentHeight - widthInner;
                }
                else if (this.rotationInner == 180) 
                {
                    xInner = -(imageContainerWidth - rectFaces.x * widthInner) + rectFaces.width * widthInner + (componentWidth - rectFaces.width * widthInner) / 2;
                    yInner = -(imageContainerHeight - rectFaces.y * heightInner) + rectFaces.height * heightInner + (componentHeight - rectFaces.height * heightInner) / 2;

                    if (xInner > 0)
                        xInner = 0;

                    if (yInner > 0)
                        yInner = 0;

                    if (xInner < componentWidth - widthInner)
                        xInner = componentWidth - widthInner;

                    if (yInner + heightInner < componentHeight)
                        yInner = componentHeight - heightInner;
                }
                else if (this.rotationInner == 270) 
                {
                    xInner = -rectFaces.y * heightInner + (componentWidth - rectFaces.height * heightInner) / 2;
                    yInner = -widthInner + rectFaces.x * widthInner + componentHeight - (componentHeight - rectFaces.width * widthInner) / 2;

                    if (xInner > 0)
                        xInner = 0;

                    if (yInner > 0)
                        yInner = 0;

                    if (xInner < (componentWidth - heightInner))
                        xInner = (componentWidth - heightInner);

                    if (yInner + widthInner < componentHeight)
                        yInner = componentHeight - widthInner;
                }
            }
        }

        if ((mode == "temporary" /*&& !this.media.hasFaces*/) || this.empty) {
            let imageXInner = 0;
            if (this.rotationInner == 0)
                imageXInner = 0;

            if (this.rotationInner == 90)
                imageXInner = imageContainerWidth;

            if (this.rotationInner == 180)
                imageXInner = imageContainerWidth;

            if (this.rotationInner == 270)
                imageXInner = 0;

            let imageYInner = 0;
            if (this.rotationInner == 0)
                imageYInner = 0;

            if (this.rotationInner == 90)
                imageYInner = 0;

            if (this.rotationInner == 180)
                imageYInner = imageContainerHeight;

            if (this.rotationInner == 270)
                imageYInner = imageContainerHeight;


            this.imageContainer.size(imageContainerWidth, imageContainerHeight)
                .attr("transform", "translate(" + xInner + "," + yInner + ")");

            this.image.size(widthInner, heightInner)
                .attr("transform", "translate(" + imageXInner + "," + imageYInner + ") rotate(" + (this.rotationInner || 0) + ")");

            if (this.empty && mode != "temporary") {
                this.emptySize.imageContainerWidth = imageContainerWidth;
                this.emptySize.imageContainerHeight = imageContainerHeight;
                this.emptySize.xInner = xInner;
                this.emptySize.yInner = yInner;
                this.emptySize.widthInner = widthInner;
                this.emptySize.heightInner = heightInner;
                this.emptySize.imageXInner = imageXInner;
                this.emptySize.imageYInner = imageYInner;
            }
        }
        else {
            this.data.update("fill", { width_inner: widthInner, height_inner: heightInner, x_inner: xInner, y_inner: yInner, zoom: 1 });
        }


        this._updateFaces();

        return true;
    }


    updateCommands() {
        super.updateCommands();

        this.command("zoomin", "disabled", this.empty || this.data.zoom >= 2);
        this.command("zoomout", "disabled", this.empty || (this.data.width_inner <= this.data.width || this.data.height_inner <= this.data.height));
        this.command("masks", "disabled", this.empty && fx.get("app") != "config");
        this.command("effects", "disabled", this.empty);
        this.command("magiceraser", "disabled", this.empty || !fx.service("MagicEraserService").canErase(this.media, this.effect));
        this.command("brightness", "disabled", this.empty);
        this.command("rotate", "disabled", this.empty);
        this.command("border", "visible", this.mask ? this.mask.empty : true);
        
        if (fx.browser.isMobile || fx.browser.isTablet)
            this.command("crop", "disabled", this.empty);
    }

    updateMedia(content, update)
    {
        super.updateMedia(content);

        // an erased version belongs to one photo : another photo dropped here shows as it is
        if (update && this.media && fx.service("MagicEraserService").isErased(this.effect) && !this.media.hasEffect(this.effect))
        {
            this.data.update({ content_type : "" });
            return;
        }

        // when adding a picture that is being uploaded, we don't apply effect
        if (update && content && !Utils.isID(content) && this.media && this.effect && !this.media.hasEffect(this.effect))
            this.media.event("apply-effect", {effect : this.effect, imageWidth : this.realWidth, imageHeight : this.realHeight});

        this.SVGElement.unfilter(true);
        this.SVGElement.filter(this.filterFCNHandler);
           this.updatePhoto();
    }

    // the media url changed (upload finished) : the blob the <image> uses has been revoked by the
    // model, point it to what the cache holds now. Placement is left untouched on purpose.
    _repointMedia() {
        if (this.empty || !this.media || !this.image)
            return;

        let cache = this.media.getCache(this.effect);

        if (!cache || !cache.data || this.image.attr('href') == cache.data)
            return;

        if (!this._temporaryImageSet)
            this.on("load", this._onMediaLoaded, this.image);

        this.image.load(cache.data);
    }

    renderMedia() {
        if (!this.empty)
            //super.renderMedia(0 /*this.rotationInner*/);
            return super.renderMedia();
        else
            this.onMediaRendered({ url: this.isSmall && !this.empty ? this.media.light_url : this.media.getUrl(), width: this.media.image.width, height: this.media.image.height, media: this.media });
    }

    onMediaRendered(rendered) {
        if (rendered.media != this.media)
            return;

        // screenshot of a creation to enhance : the picture is shown once its colours are corrected,
        // so "media-loaded" (which lets the screenshot be taken) only comes with the corrected one
        if (this.enhancing && !(this.media instanceof models.EmptyMedia)) {
            this._pendingRendered = rendered;

            enhance.PhotoEnhancer.shared.enhance(rendered.url, {
                photoCorrection: !(fx.get("settings").enhanceKeepCustomerLook && this.hasCustomerLook),
                simulatePaper: fx.get("simulate-paper")
            })
                .then((url) => {
                    // a newer rendering was asked for in between, or the component is gone
                    if (this._pendingRendered !== rendered || rendered.media != this.media || !this.image)
                        return;

                    this._pendingRendered = null;
                    this._showRendered(rendered, url);
                });

            return;
        }

        this._showRendered(rendered, rendered.url);
    }

    // rendered.url is the media's own url, href the one the <image> shows (the colour corrected picture when enhancing)
    _showRendered(rendered, href) {
        if (this.image.attr('href') != href) {
            if (!this._temporaryImageSet) {
                if (this.media instanceof models.EmptyMedia)
                    this._onMediaLoaded();
                else
                    this.on("load", this._onMediaLoaded, this.image);
            }

            this.image.load(href);
        }

        this.photoDimensions = { width: rendered.width, height: rendered.height };

        this._toFill = this._toFill || this.empty;

        if (this._toFill) {
            if (this.fill(this._toFill))
                if (rendered.url != this.media.getThumb(this.effect))
                    this._toFill = null;
        }
        

        this.updateEmpty();

        this._checkResolution();

        if (rendered.url != this.media.getThumb(this.effect) /*this.media.thumb*/)
            this._progressBackground.remove();
    }

    _onMediaLoaded() {
        if (this.data)
            this.data.event("media-loaded", null, 500);

        if (this.image)
            this.off("load", this._onMediaLoaded, this.image);
    }

    refresh() {
        super.refresh();
        this.updateEmpty();
    }

    updateEmpty() {
        if (!this.SVGElement || this.parentScale < 0.5)
            return;

        if (this.empty) {
            if (!this.emptyElement) {
                this.emptyElement = new fx.components.Box("empty-block center");

                this.emptyElement.addChild(new fx.components.Image(fx.assets.plusBtn), { width: fx.browser.isDesktop ? 15 : 10, height: fx.browser.isDesktop ? 15 : 10, top: "center", left: "center" });
                this.addChild(this.emptyElement, { width: fx.browser.isDesktop ? 30 : 20, height: fx.browser.isDesktop ? 30 : 20, left: fx.browser.isDesktop ? 0 : "center", top: fx.browser.isDesktop ? 0 : "center" });
            }

            if (fx.browser.isDesktop) {
                let scale = this.parentScale;
                /*if (scale < 2)
                    scale = 2;*/

                let x = (this.width - this.emptyElement.width() / scale) / 2 * scale;
                let y = (this.height - this.emptyElement.height() / scale) / 2 * scale;
                this.emptyElement.css("transform", "scale(" + (1 / scale) + ") translate(" + x + "px," + y + "px)");
            }

            this.addClass("empty");
        }
        else {
            if (this.emptyElement)
                this.emptyElement.destroy()

            this.emptyElement = null;

            this.removeClass("empty");
        }
    }

    updateBorder() {
        if (!this.data)
            return;

        if (this.data.borderid != 0)
            this.css("outline", "solid " + this.data.borderid + "px " + this.data.side);
        else
            if (!this.empty)
                this.css("outline", "none");
    }

    onDisplayUpdated() {
        super.onDisplayUpdated();

        if (this.mediaLoaded && !this.draggingOver) {
            this._updatePhoto();

            this.updateCommands();
        }

    }


    addPositionWarning(val) {
        if (fx.browser.isMobile) return;

        this.showWarning(val, fx.text("Ne placez pas visages au niveau de la séparation des pages,<br>ils risquent de ne pas se recouper parfaitement après la fabrication."));

        if (!val)
            this._checkResolution();

        this.delay(this.showWarning, 5000);
    }


    _updatePhoto() {
        this.css({
            width: this.width + "px",
            height: this.height + "px"
        });

        this.svg.attr("width", this.width + "px");
        this.svg.attr("height", this.height + "px");
        this.svg.viewbox(0, 0, this.width, this.height);


        if (this.clip) {
            this.clip.size(this.width + this._clipfix, this.height + this._clipfix);
            this.clip.move(0, 0);
        }

        /*if (this.maskElement)
            this.maskElement.size(this.width, this.height);*/

        // while a picture is dragged over, the inner geometry on screen is the temporary one set by
        // fill("temporary") for the hovered picture : re-applying the stored one here would undo it
        // ("drag-out" restores it explicitly when the drag leaves)
        if (!this.draggingOver) {
            this.imageContainer.size(this.imageContainerWidth, this.imageContainerHeight)
                .attr("transform", "translate(" + this.xInner + "," + this.yInner + ")");

            this.image.size(this.widthInner, this.heightInner)
                .attr("transform", "translate(" + this.imageXInner + "," + this.imageYInner + ") rotate(" + (this.rotationInner || 0) + ")");
        }

        if (this.photoEffect)
            this.photoEffect.resize(this.width, this.height);

        if (this.mask && this.mask.custom)
            this.maskElement.size(this.width, this.height).move(0, 0);

        this.updateEmpty();
    }



    destroy() {
        super.destroy();

        this.removeClip();
        this.removeCustomMask();
        /*
        if (this.clip)
            this.clip.remove();

        if (this.clipSVG && this.clipSVG.parent())
            this.clipSVG.remove();*/

        if (this.photoEffect)
            this.photoEffect.clear();

        if (this.image)
            this.image.remove();

        if (this.imageContainer)
            this.imageContainer.remove()
    }

    /****************** Actions / Events *********************/

    onCrop() {
        //if (!this.empty)
        //    this.data.event("edit-photo", this.data);
        //else
        this.data.event("switch-photoPanel", this.data);
    }

    onChangePhoto() {
        //this.data.event("switch-photoPanel", this.data);
        this.data.event("edit-photo", this.data);
    }

    onReplacePhoto() {
        this.model.event("selectphotos", this.data);
    }

    onZoomOut() {
        this._applyZoom(- 0.2);
    }

    onZoomIn() {
        this._applyZoom(+ 0.2);
    }


    _applyZoom(val, setZoom, returnValue) {
        let scaledWidth,
            scaledHeight,
            widthInner,
            heightInner;

        if (!this.photoDimensions) return;

        if (this.rotationInner == 0 || this.rotationInner == 180) {
            scaledWidth = Number(this.data.height) * this.photoDimensions.width / this.photoDimensions.height;
            scaledHeight = Number(this.data.width) * this.photoDimensions.height / this.photoDimensions.width;


            if (scaledWidth >= Number(this.data.width)) {
                widthInner = scaledWidth;
                heightInner = Number(this.data.height);
            }
            else {
                widthInner = Number(this.data.width);
                heightInner = scaledHeight;
            }
        }
        else // 90 - 270
        {
            scaledWidth = Number(this.data.width) * this.photoDimensions.width / this.photoDimensions.height;
            scaledHeight = Number(this.data.height) * this.photoDimensions.height / this.photoDimensions.width;

            if (scaledWidth > Number(this.data.height)) {
                heightInner = Number(this.data.width);
                widthInner = scaledWidth;
            }
            else {
                widthInner = Number(this.data.height);
                heightInner = scaledHeight;
            }

        }


        let zoom = setZoom ? val : ((this.data.width_inner / widthInner) + val);
        zoom = Math.max(1, Math.min(2, zoom));

        // new size
        widthInner = widthInner * zoom;
        heightInner = heightInner * zoom;


        // center zoomed image
        let x,
            y,
            ratio,
            newX,
            newY,
            x_inner,
            y_inner;



        x = Math.abs(this.data.x_inner) + Number(this.data.width) / 2;
        y = Math.abs(this.data.y_inner) + Number(this.data.height) / 2;


        ratio = widthInner / this.data.width_inner;
        newX = x * ratio;
        newY = y * ratio;
        x_inner = this.data.x_inner - (newX - x);
        y_inner = this.data.y_inner - (newY - y);


        if (this.rotationInner == 0) {
            if (x_inner > 0)
                x_inner = 0;

            if (x_inner < (this.data.width - widthInner))
                x_inner = this.data.width - widthInner;

            if (y_inner > 0)
                y_inner = 0;

            if (y_inner < (this.data.height - heightInner))
                y_inner = this.data.height - heightInner;
        }
        else
            if (this.rotationInner == 90) {
                if (x_inner > 0)
                    x_inner = 0;

                if (y_inner > 0)
                    y_inner = 0;

                if (x_inner < -(heightInner - this.data.width))
                    x_inner = -(heightInner - this.data.width);

                if (y_inner < - (widthInner - this.data.height))
                    y_inner = - (widthInner - this.data.height);
            }
            else
                if (this.rotationInner == 180) {
                    if (x_inner > 0)
                        x_inner = 0;

                    if (y_inner > 0)
                        y_inner = 0;

                    if (x_inner < -(widthInner - this.data.width))
                        x_inner = -(widthInner - this.data.width);

                    if (y_inner < -(heightInner - this.data.height))
                        y_inner = -(heightInner - this.data.height);

                }
                else
                    if (this.rotationInner == 270) {
                        if (x_inner > 0)
                            x_inner = 0;

                        if (y_inner > 0)
                            y_inner = 0;

                        if (x_inner < -(heightInner - this.data.width))
                            x_inner = -(heightInner - this.data.width);

                        if (y_inner < -(widthInner - this.data.height))
                            y_inner = -(widthInner - this.data.height);
                    }

        if (returnValue)
            return { zoom: zoom, x_inner: x_inner, y_inner: y_inner, width_inner: widthInner, height_inner: heightInner };
        else
            this.data.update({ zoom: zoom, x_inner: x_inner, y_inner: y_inner, width_inner: widthInner, height_inner: heightInner });
    }


    onBorder(data) {
        this.data.update({ borderid: data.thickness, side: data.color })

        if (this.model)
            this.model.customcolors.addColor(data.color, this.model.creation.id);
    }

    onSetMask(mask) {
        if (mask) {
            let data = { photomask: mask.id };

            // if mask is not the full rectangle (empty == 1), we remove border
            if (!mask.empty)
                data.borderid = 0;

            this.data.update(data);
        }

    }

    onSetEffect(photoEffect) {
        if (photoEffect)
            this.data.update({ effectName: photoEffect.id })
    }

    onSetBrightness() {
        this.SVGElement.unfilter(true);
        this.SVGElement.filter(this.filterFCNHandler);
    }

    // add brightness filters to current effect filter (sepia, black and white, etc..))
    filterFCNBrightness(add) {
        filters.PhotoFilters.chain(add, this.data, this.photoEffect, this.image, !!(this.data.content || this.draggingOver));
    }

    onApplyRotate() {
        this.rotatePhoto();
    }

    onMagicEraser() {
        if (!this.empty)
            this.model.event("magic-eraser", this.data);
    }

    onDelete() {
        this.deletePhoto();
    }

    rotatePhoto() {
        let angle = Number(this.rotationInner) + 90;
        angle = (angle == 360) ? 0 : angle;

        this.data.update({ rotation_inner: angle, zoom: 1 })
    }

    deletePhoto(full) {
        if (this.empty || full)
            this.data.delete();
        else
            this.data.update({ content: "", rotation_inner: 0 });
    }


    /***************************************/

    _checkResolution() {
        if (this.single || this.preview || this.draggingOver)   // preview
            return false;

        if (!this.media || this.empty /*|| (fx.browser.isMobile || fx.browser.isTablet)*/) {
            this.showWarning(false)
        }
        else {
            let creation = this.model ? this.model.creation : null;
            
            // width_inner is in the editor's normalized coordinate base (creation.pageWidth).
            // Scale it to the real printed size in mm using the product's physical format.
            let scale = (creation && creation.pageWidth) ? (creation.realPageWidth / creation.pageWidth) : 1;

            // real printed width of the photo, in centimeters
            let realWidthCm = (this.data.width_inner * scale) / 10;

            let density = this.media.getImageWidth(this.effect) / realWidthCm;// / 10 *  (96 / 2.54)) ;
            let warning = density < fx.get("settings").minDensity;

            //if (!fx.browser.isMobile)
            this.showWarning(warning, fx.text("Votre photo n'est pas de qualité suffisante. Réduisez sa taille, ou remplacez-la par une meilleure photo."));

            //if (warning)
            //    this.delay(this._removeWarning, 10000);
        }
    }

    showWarning(create, text) {
        super.showWarning(create, text);

        if (!create) {
            if (this.empty)
                this.toolTip = fx.text("Cliquer pour ajouter une photo");
        }
    }

    _removeWarning() {
        this.showWarning(false);
    }

    _autoCorrectColors()  // auto-correct picture luminosity
    {
        // the enhancer already compensates the paper : no second brightening on top
        if (this.enhancing)
            return;

        if (fx.get("auto-correct-colors")) {
            if (this.data.effectName != "")
                return;

            this.data.luminosity += 10;
            this.data.contrast -= 5;
            this.data.saturation += 5;
        }
    }

});